import React from 'react'
import { styled } from '@mui/system'
import { Spinner } from '../../Components/Icons'
import { colors } from '../../Components/consts'

type StyleProps = {
  size: 'lg' | 'sm'
}

export const CardLoadingCon = styled('div')<StyleProps>(({ size, theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: 20,
  minHeight: 300,
  '& .image': {
    width: '100%',
    height: size === 'lg' ? '50vh' : '10vh',
    background: '#FAFAFA',
    borderRadius: 20,
    margin: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > svg': {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(2),
    },
  },
  '& .title': {
    height: 20,
    width: '80%',
    margin: theme.spacing(1),
    background: '#FAFAFA',
  },
}))

type CardLoadingProps = {
  size: 'lg' | 'sm'
}

export const CardLoading: React.FC<React.PropsWithChildren<CardLoadingProps>> = ({
  size,
}) => {
  return (
    <CardLoadingCon size={size}>
      <div className="image">
        <Spinner fill={colors.yellow} />
        Loading...
      </div>
      <div className="title" />
    </CardLoadingCon>
  )
}
